import { apiClientAuth } from "../http/httpClient";


export function AccountbilityApi(contentType = "application/json")
{
    const https = apiClientAuth(contentType);

    return {

       /**
        * GET /api/statistics/total
        * @desc    Get total statistics for validated orders, expenses and paid debts
        * @access  Private (Admin)
        * @returns {Object} Object with total amounts:
        *   - ordersValidated: total amount of delivered orders
        *   - expenses: total amount of all expenses
        *   - debtsPaid: total amount of paid debts
        *   - total: sum of all above amounts
        */
        getAllStat: () => https.get(`/api/statistics/total`),

       /**
        * GET /api/statistics/orders/year
        * @desc    Get total amount of validated orders by month for current year
        * @access  Private (Admin)
        * @returns {Object} Array of monthly data for delivered orders:
        *   - month: month name in French
        *   - monthNumber: numeric month (1-12)
        *   - totalAmount: sum of order amounts for that month
        */
        getOrderStatOfYear: () => https.get(`/api/statistics/orders/year`),

       /**
        * GET /api/statistics/orders/years
        * @desc    Get total amount of validated orders by year for last 8 years
        * @access  Private (Admin)
        * @returns {Object} Array of yearly data for delivered orders:
        *   - year: year number
        *   - totalAmount: sum of order amounts for that year
        */
        getOrderStatOfYears: () => https.get(`/api/statistics/orders/years`),

       /**
        * GET /api/statistics/maintenances/year
        * @desc    Get total count of completed maintenances by month for current year
        * @access  Private (Admin)
        * @returns {Object} Array of monthly data for done maintenances:
        *   - month: month name in French
        *   - monthNumber: numeric month (1-12)
        *   - totalCount: count of completed maintenances for that month
        */
        getMaintenanceStatOfYear: () => https.get(`/api/statistics/maintenances/year`),

       /**
        * GET /api/statistics/maintenances/years
        * @desc    Get total count of completed maintenances by year for last 8 years
        * @access  Private (Admin)
        * @returns {Object} Array of yearly data for done maintenances:
        *   - year: year number
        *   - totalCount: count of completed maintenances for that year
        */
        getMaintenanceStatOfYears: () => https.get(`/api/statistics/maintenances/years`),

       /**
        * GET /api/statistics/expenses/year
        * @desc    Get total amount of expenses by month for current year
        * @access  Private (Admin)
        * @returns {Object} Array of monthly data for all expenses:
        *   - month: month name in French
        *   - monthNumber: numeric month (1-12)
        *   - totalAmount: sum of expense amounts for that month
        */
        getExpenseStatOfYear: () => https.get(`/api/statistics/expenses/year`),

       /**
        * GET /api/statistics/expenses/years
        * @desc    Get total amount of expenses by year for last 8 years
        * @access  Private (Admin)
        * @returns {Object} Array of yearly data for all expenses:
        *   - year: year number
        *   - totalAmount: sum of expense amounts for that year
        */
        getExpenseStatOfYears: () => https.get(`/api/statistics/expenses/years`),

    };
}

